export default {
  en: {
    visitSiteLabel: 'Visit Site',
    viewProfileLabel: 'View Profile',
    featuredVideosLabel: 'Featured Videos',
    featuredProductsLabel: 'Featured Products',
    'view more': 'View more',
    videos: 'videos',
    products: 'products',
  },
  es: {
    visitSiteLabel: 'Visite el sitio web',
    viewProfileLabel: 'Vea el perfil',
    featuredVideosLabel: 'Videos destacados',
    featuredProductsLabel: 'Productos destacados',
    'view more': 'Vea más',
    videos: 'videos',
    products: 'productos',
  },
  pt: {
    visitSiteLabel: 'Visite o site',
    viewProfileLabel: 'Ver perfil',
    featuredVideosLabel: 'Vídeos em destaque',
    featuredProductsLabel: 'Produtos em destaque',
    'view more': 'Ver mais',
    videos: 'vídeos',
    products: 'produtos',
  },
};
